import CloseIcon from "@mui/icons-material/Close";
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { useSinisterSummary } from "../../../sinister/hooks/useSinisterSummary";
import { useTotalLmi } from "../../../sinister/hooks/useTotalLMI";
import SinisterSectionList from "../../../sinister/components/SinisterCardData/SinisterSectionList";
import { buildSinisterSections } from "../../../sinister/components/SinisterCardData/sections";
import { ISinisterRow } from "../../../sinister/types/fieldsconfig";
import { getStatusColorsSinister } from "../../../../shared/utils/globalColorSinister";
import { globalTranslateSinister } from "../../../../shared/utils/globalTranslateSinister";
import { ModalSinisterValues } from "./ModalSinisterValues";

interface Props {
	open: boolean;
	sinisterId: string;
	onClose: () => void;
}

const ModalSinisterDetailsContent = ({ sinisterId, onClose }: { sinisterId: string; onClose: () => void }) => {
	const { responsibleName, totalBordero, rowSummary: rows, isLoading } = useSinisterSummary(sinisterId);
	const { data: totalLmi } = useTotalLmi(sinisterId);
	const [openValuesModal, setOpenValuesModal] = useState(false);

	if (isLoading || !rows) {
		return (
			<>
				<LoadingComp isopen />
				<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
						Detalhes do Sinistro
					</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon fontSize="small" />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers sx={{ minHeight: 200 }} />
			</>
		);
	}

	const { bg, color } = getStatusColorsSinister(rows.status);
	const sections = buildSinisterSections(
		rows as unknown as ISinisterRow,
		totalLmi ? { lmiTotal: totalLmi.lmiTotal, saldo: totalLmi.saldo } : { lmiTotal: "", saldo: "" },
		totalBordero ?? 0,
		responsibleName
	);

	return (
		<>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Stack direction="row" spacing={2} alignItems="center">
					<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
						Detalhes do Sinistro
					</Typography>
					<Chip
						size="medium"
						label={globalTranslateSinister(rows.status)}
						sx={{ color, backgroundColor: bg, fontWeight: 500, border: "0.5px solid #f1f1f1" }}
					/>
				</Stack>

				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers sx={{ px: { xs: 3, md: 4 }, py: 2, bgcolor: "background.paper" }}>
				<SinisterSectionList sections={sections} />
			</DialogContent>

			<DialogActions sx={{ px: { xs: 3, md: 4 }, py: 2.5, bgcolor: "background.paper" }}>
				<Button variant="outlined" onClick={() => setOpenValuesModal(true)}>
					Ver Valores
				</Button>
			</DialogActions>

			<ModalSinisterValues open={openValuesModal} sinisterId={sinisterId} onClose={() => setOpenValuesModal(false)} />
		</>
	);
};

export const ModalSinisterDetails = ({ open, sinisterId, onClose }: Props) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
			<ModalSinisterDetailsContent sinisterId={sinisterId} onClose={onClose} />
		</Dialog>
	);
};
